export default {
  getterListProductCategory: state => state.listCategory,
  getterListProduct: state => state.listProduct,
  getterListRegion: state => state.listRegion,
  getterListCluster: state => state.listCluster,
  getterListAttribute: state => state.listAttribute,
}
